<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="local_shipping"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ `${$t('linehaul')} ${$t('from').toLowerCase()}:` }}
        </div>
        <v-autocomplete
          v-model="selectedGroup"
          item-text="full_name"
          item-value="iso"
          hide-selected
          :items="countries"
          class="group-select"
        />
      </template>
      <v-divider class="my-3" />
      <div>
        <v-simple-table
          fixed-header
          dense
          class="elevation-1"
        >
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  v-for="header in headers"
                  :key="header"
                  class="text-left"
                >
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tbody
              v-for="(g, key) in groups"
              v-show="key === selectedGroup"
              :key="`${key}`"
            >
              <tr
                v-for="(entry, groupKey) in g"
                :key="`${key}_${groupKey}`"
              >
                <td style="min-width: 175px;">
                  <v-select
                    v-model="entry.receiver_countries"
                    item-text="iso"
                    item-value="iso"
                    small-chips
                    deletable-chips
                    multiple
                    hide-selected
                    :items="countries"
                  />
                </td>
                <td style="min-width: 70px;">
                  <v-text-field
                    :value="entry.base_cost"
                    dense
                    type="number"
                    min="0.00"
                    step="0.01"
                    suffix="kr"
                  />
                </td>

                <td
                  v-for="(interval, intervalIndex) in entry.table"
                  :key="interval"
                  style="min-width: 70px;"
                >
                  <v-text-field
                    :value="interval"
                    :placeholder="getIntervalPlaceholder(intervalIndex, entry.base_cost)"
                    dense
                    type="number"
                    min="0.00"
                    step="0.01"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </base-material-card>
  </v-container>
</template>
<script>
  export default {
    data () {
      return {
        endpoint: 'linehaul',
        name: 'linehaul',
        loading: false,
        selectedGroup: 'DK',
        countries: [],
        headers: [

        ],
        groups: {},
        raw: {
          intervals: [
            10,
            20,
            30,
            40,
            50,
            60,
            70,
            80,
            90,
            100,
            110,
            120,
            130,
            140,
            150,
            160,
            170,
            180,
            190,
            200,
          ],
          groups: {
            DK: [
              {
                id: 7,
                receiver_countries: [
                  'DK',
                ],
                base_cost: 500,
                table: {
                  10: null,
                  20: null,
                  30: null,
                  40: null,
                  50: 5,
                  60: null,
                  70: null,
                  80: null,
                  90: null,
                  100: null,
                  110: null,
                  120: null,
                  130: null,
                  140: null,
                  150: null,
                  160: null,
                  170: null,
                  180: null,
                  190: null,
                  200: null,
                },
              },
              {
                id: 8,
                receiver_countries: [
                  'ZA',
                  'VA',
                  'NG',
                  'MN',
                  'Z6',
                  'VC',
                  'CM',
                  'Z4',
                ],
                base_cost: 592,
                table: {
                  10: null,
                  20: null,
                  30: null,
                  40: null,
                  50: null,
                  60: null,
                  70: null,
                  80: null,
                  90: null,
                  100: null,
                  110: null,
                  120: null,
                  130: null,
                  140: null,
                  150: null,
                  160: null,
                  170: null,
                  180: null,
                  190: null,
                  200: null,
                },
              },
              {
                id: 9,
                receiver_countries: [
                  'ID',
                  'NA',
                  'ZM',
                  'RS',
                  'DO',
                  'UM',
                  'KZ',
                  'Z7',
                  'CG',
                ],
                base_cost: 536,
                table: {
                  10: null,
                  20: null,
                  30: null,
                  40: null,
                  50: null,
                  60: null,
                  70: null,
                  80: null,
                  90: null,
                  100: null,
                  110: null,
                  120: null,
                  130: null,
                  140: null,
                  150: null,
                  160: null,
                  170: null,
                  180: null,
                  190: null,
                  200: null,
                },
              },
              {
                id: 10,
                receiver_countries: [
                  'DZ',
                  'JP',
                  'IM',
                  'FJ',
                  'MU',
                  'AE',
                  'SV',
                  'PN',
                  'YT',
                  'Z3',
                ],
                base_cost: 482,
                table: {
                  10: null,
                  20: null,
                  30: null,
                  40: null,
                  50: null,
                  60: null,
                  70: null,
                  80: null,
                  90: null,
                  100: null,
                  110: null,
                  120: null,
                  130: null,
                  140: null,
                  150: null,
                  160: null,
                  170: null,
                  180: null,
                  190: null,
                  200: null,
                },
              },
              {
                id: 11,
                receiver_countries: [
                  'GQ',
                  'GM',
                  'TJ',
                  'AZ',
                  'BZ',
                  'SA',
                  'PS',
                  'RO',
                  'NR',
                  'ER',
                ],
                base_cost: 533,
                table: {
                  10: null,
                  20: null,
                  30: null,
                  40: null,
                  50: null,
                  60: null,
                  70: null,
                  80: null,
                  90: null,
                  100: null,
                  110: null,
                  120: null,
                  130: null,
                  140: null,
                  150: null,
                  160: null,
                  170: null,
                  180: null,
                  190: null,
                  200: null,
                },
              },
              {
                id: 12,
                receiver_countries: [
                  'SR',
                  'CZ',
                  'DJ',
                  'AG',
                  'TC',
                  'XK',
                  'MW',
                  'KH',
                  'TT',
                  'GA',
                ],
                base_cost: 488,
                table: {
                  10: null,
                  20: null,
                  30: null,
                  40: null,
                  50: null,
                  60: null,
                  70: null,
                  80: null,
                  90: null,
                  100: null,
                  110: null,
                  120: null,
                  130: null,
                  140: null,
                  150: null,
                  160: null,
                  170: null,
                  180: null,
                  190: null,
                  200: null,
                },
              },
              {
                id: 13,
                receiver_countries: [
                  'GR',
                  'ZM',
                  'PR',
                  'RE',
                  'PG',
                  'MW',
                  'CI',
                  'ID',
                  'DZ',
                  'TH',
                ],
                base_cost: 491,
                table: {
                  10: null,
                  20: null,
                  30: null,
                  40: null,
                  50: null,
                  60: null,
                  70: null,
                  80: null,
                  90: null,
                  100: null,
                  110: null,
                  120: null,
                  130: null,
                  140: null,
                  150: null,
                  160: null,
                  170: null,
                  180: null,
                  190: null,
                  200: null,
                },
              },
            ],
          },
        },

      }
    },
    created: function () {
      this.setTableData()
      this.getCountries()
    },
    methods: {
      setTableData: function () {
        this.headers = [this.$t('countries'), this.$t('base_cost'), ...this.raw.intervals]
        this.groups = this.raw.groups
      },
      getIntervalPlaceholder: function (intervalIndex, baseCost) {
        return (baseCost / intervalIndex).toFixed(2)
      },
      getCountries: function () {
        this.$get('/countries', { limit: 999 }).then(r => {
          this.countries = r.data.data
        })
      },
    },
  }
</script>

<style lang="scss">
    .group-select {
        padding-top: 0;
        margin-left: 10px;
        margin-top: 8px;
        input {
            font-size: 2.25rem !important;
        }
    }
</style>
